import "@sourceflow-uk/job-search/dist/bundle.css";
import Search from "@/assets/Search.svg";
import JobSearch from "@sourceflow-uk/job-search";
import JobType from "@/../.sourceflow/jobs-Contract Type.json";
import InternalJob from "@/../.sourceflow/jobs-Internal Jobs.json";
// import Sector from "@/../.sourceflow/jobs-Sector.json";
import PropTypes from "prop-types";
import { Container, Row, FormCheck, Stack } from "react-bootstrap";
import { CTA } from "@/ui";
import classes from "./styles.module.scss";
import clsx from "classnames";
import JobCard from "../JobCard";
import DiscoverScroll from "../DiscoverScroll";
import Breadcrumb from "../Breadcrumb";

function Result({}) {

  const interval = setInterval(checkForStrongElement, 1);

  function checkForStrongElement() {
    const totalCountsElement = document.querySelector('.js-total-count');

    if (!totalCountsElement) return;
    const strongElement = totalCountsElement.querySelector('strong');

    if (strongElement) {
      clearInterval(interval);
    }

    boldNumber();
  }

  function boldNumber() {
    const totalCountsElement = document.querySelector('.js-total-count');

    if (!totalCountsElement) return;

    const textContent = totalCountsElement.textContent;

    const words = textContent.split(' ');
    const lastWord = words[1];
    const numberPart = parseInt(lastWord, 10);

    totalCountsElement.innerHTML = textContent.replace(lastWord, `<strong>${numberPart}</strong>`);
  }

  return (<></>);
}


export default function JobsFeed({ className, sector, changeURLOnFilterChange }) {
  
  return (
    <div className={clsx(classes.feed)} style={{paddingTop: "60px"}}>
      <div style={{padding: "0 60px"}}>
        <Breadcrumb label="Find Your Next Job" />
      </div>
      <div className={classes.hero}>
        <div className={classes.header}>
          <h1 className={classes.header_title}>FIND YOUR NEXT JOB <div className={classes.header_title_block}/></h1>
        </div>
        <div className={classes.search_placeholder}></div>
        <div className={classes.scroll}>
          <DiscoverScroll/>
        </div>
      </div>
        <JobSearch
          options={{
            jobsUrl: "/jobs/",
            // prefilters: {
            //   "3186657c-e89c-4a6f-9157-35eb7fe0b379": [sector],
            // },
            urlFilters: {
              mode: "active",
              jobCategories: [JobType, InternalJob],
              changeURLOnFilterChange: changeURLOnFilterChange,
            },
            searchInput: {
              queryInput: true,
              locationInput: true
            },
            searchFiltersOptions: {
              exclude: {
                "f29db1d5-61be-406d-8b54-011445703b7a": true,
              },
              filterUnselectedElement: <FormCheck />,
              filterSelectedElement: <FormCheck checked />,
              // exclude: {
              //   "a82e2fc2-7013-4836-98aa-02667db9d824": true,
              //   "3186657c-e89c-4a6f-9157-35eb7fe0b379": [sector],
              // },
            },
             searchResults: ({ results }) =>
              results && (
              <>
                <Row>
                    {results.map(( job, index ) => (
                      <div key={index} className="list-item">
                          <JobCard job={job.job} />
                          <Result results={results}></Result>
                      </div>
                    ))}
                </Row>
              </>
            )
          }}
          translations={{
            "filters.toggleButtonText": "FILTER BY",
            "searchResults.resultsTotalCount": "Search {{count}} Vacancies",
            "searchResults.buttonText": "View job",
            "button.text": (
              <Stack className="flex-row align-items-center justify-content-center px-3" gap={2}>
                <Search />
              </Stack>
            ),
          }}
        />
    </div>
  );
}

JobsFeed.defaultProps = {
  className: "py-4 py-md-5",
  sector: null,
  changeURLOnFilterChange: true,
};

JobsFeed.propTypes = {
  className: PropTypes.string,
  sector: PropTypes.string,
};
